<template>
  <el-dialog
    title="编辑资产"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <!-- 选择显示 -->
      <div class="select-box">
        <div class="btn" :class="{'active':showBasics}" @click="showFun(1)">基本信息</div>
        <div class="btn" :class="{'active':showOther}" @click="showFun(2)">其它信息</div>
      </div>
    <!-- :model="form" -->
    <el-form
      v-if="formData"
      size="small"
      :model="copyForm"
      :rules="rules"
      ref="copyForm"
      v-loading="formLoading"
    >
    <div v-for="(item,index) in formItems" :key="index">
      <!-- 基础 -->
      <div v-if="showBasics">
        <template v-if="item.type === 'input' && item.rules.required">
          <el-form-item :label="item.text" :label-width="formLabelWidth" :key="item.name">
            <el-input
                v-model="copyForm[item.name]"
                autocomplete="off"
                :disabled="item.disabled"
                :placeholder="item.placeholder"
              ></el-input>
          </el-form-item>
        </template>
        <template v-if="item.type === 'number'">
            <el-form-item :label="item.text" :label-width="formLabelWidth" :key="item.name">
              <el-input
                v-model="copyForm[item.name]"
                type="number"
                autocomplete="off"
                :disabled="item.disabled"
                :placeholder="item.placeholder"
              ></el-input>
            </el-form-item>
        </template>
        <template v-if="item.type === 'autocomplete'">
          <el-form-item :label="item.text" :label-width="formLabelWidth" :key="item.name">
            <el-autocomplete
              v-model="copyForm[item.name]"
              :fetch-suggestions="querySearchAsync(item)"
              :placeholder="item.placeholder"
              :disabled="item.disabled"
              placement="bottom"
              v-bind="item.option"
              @change.native="handleChange"
              @select="handleSelect"
            ></el-autocomplete>
          </el-form-item>
        </template>
        <template v-if="item.type === 'datetime'">
          <el-form-item :label="item.text" :label-width="formLabelWidth" :key="item.name">
            <el-date-picker
              type="datetime"
              v-model="copyForm[item.name]"
              :placeholder="item.placeholder"
              :disabled="item.disabled"
            >
            </el-date-picker>
          </el-form-item>
        </template>
        <template v-if="item.type === 'contract'">
          <el-form-item :label="item.text" :label-width="formLabelWidth" :key="item.name">
            <div class="contract-list" v-if="item.type === 'contract'">
              <draggable class="wrapper" v-model="copyForm.contract">
                <transition-group>
                  <div v-for="(list,index) in copyForm.contract" :key="list.file_path">
                    <div class="item">
                      <el-image
                        :src="list.file_path"
                        :preview-src-list="[list.file_path]"
                        class="img-auto"
                        >
                      </el-image>
                      <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i class="el-icon-close"></i></a>
                    </div>
                  </div>
                </transition-group>
              </draggable>
              <div class="item img-select" @click="openProductUpload">
                <i class="el-icon-plus"></i>
              </div>
            </div>
          </el-form-item>
        </template>
      </div>
      <!-- 其它 -->
      <div v-if="showOther">
        <template v-if="item.type === 'input' && !item.rules.required">
          <el-form-item :label="item.text" :label-width="formLabelWidth" :key="item.name">
            <el-input
                v-model="copyForm[item.name]"
                autocomplete="off"
                :disabled="item.disabled"
                :placeholder="item.placeholder"
              ></el-input>
          </el-form-item>
        </template>
        <template v-if="item.type === 'radio'">
          <el-form-item :label="item.text" :label-width="formLabelWidth" :key="item.name">
            <el-select v-model="copyForm[item.name]" placeholder="请选择" :disabled="item.disabled">
              <el-option
                v-for="option in item.option"
                :key="option.value"
                :label="option.label"
                :value="option.value"
              >
                {{ option.label }}
              </el-option>
            </el-select>
          </el-form-item>
        </template>
      </div>
      <!-- item.rules.required -->

    </div>
      <!-- 动态渲染 -->
      <template v-if="formItems">
        <el-form-item
          v-for="item in 0"
          :label="item.text"
          :label-width="formLabelWidth"
          :key="item.name"

        >
          <!-- 其它渲染信息 -->
          <!-- :prop="item.name" -->
          <!-- <template v-if="item.type === 'input'">
            <el-input
              v-model="copyForm[item.name]"
              autocomplete="off"
              :disabled="item.disabled"
              :placeholder="item.placeholder"
            ></el-input>
          </template> -->
          <!-- 基础 -->
          <template>
              <!-- <template v-if="item.type === 'number'">
                <el-input
                  v-model="copyForm[item.name]"
                  type="number"
                  autocomplete="off"
                  :disabled="item.disabled"
                  :placeholder="item.placeholder"
                ></el-input>
              </template> -->

              <!-- <template v-if="item.type === 'radio'">
                <el-radio-group v-model="copyForm[item.name]">
                  <el-radio
                    v-for="option in item.option"
                    :key="option.value"
                    :label="option.value"
                    :disabled="item.disabled"
                    >{{ option.label }}</el-radio
                  >
                </el-radio-group>
              </template> -->
              <!-- v-if="item.text === '资产类型'" -->
              <!-- <template v-if="item.type === 'radio'">
                <el-select v-model="copyForm[item.name]" placeholder="请选择" :disabled="item.disabled">
                  <el-option
                    v-for="option in item.option"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
                  >
                    {{ option.label }}
                  </el-option>
                </el-select>
              </template> -->
              <!-- <el-select @change="provinceChange" v-model="form.province_name" filterable  placeholder="请选择省份">
                  <el-option
                      v-for="item in province_options"
                      :key="item.id"
                      :label="item.name"
                      :value="item">
                  </el-option>
              </el-select> -->

              <!-- <template v-if="item.type === 'autocomplete'">
                <el-autocomplete
                  v-model="copyForm[item.name]"
                  :fetch-suggestions="querySearchAsync(item)"
                  :placeholder="item.placeholder"
                  :disabled="item.disabled"
                  placement="bottom"
                  v-bind="item.option"
                  @change.native="handleChange"
                  @select="handleSelect"
                >
                </el-autocomplete>
              </template> -->

              <!-- <template v-if="item.type === 'datetime'">
                <el-date-picker
                  type="datetime"
                  v-model="copyForm[item.name]"
                  :placeholder="item.placeholder"
                  :disabled="item.disabled"
                >
                </el-date-picker>
              </template> -->

              <!-- 上传图片 -->
              <!-- <el-form-item  :label-width="formLabelWidth" > -->
                <!-- <div class="draggable-list" v-if="item.type === 'contract'">
                  <draggable class="wrapper" v-model="copyForm.contract">
                    <transition-group>
                      <div v-for="(list,index) in copyForm.contract" :key="list.file_path">
                        <div class="item">

                          <img v-img-url="list.file_path" alt="file_path"/>
                          <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i class="el-icon-close"></i></a>
                        </div>
                      </div>
                    </transition-group>
                  </draggable>
                  <div class="item img-select" @click="openProductUpload">
                    <i class="el-icon-plus"></i>
                  </div>
                </div> -->
              <!-- </el-form-item> -->
          </template>

        </el-form-item>

      </template>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button
        type="primary"
        @click="submitApi"
        :loading="loading && open_edit"
        >确定</el-button
      >
    </div>
    <!--商品图片组件-->
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
  </el-dialog>
</template>

<script>
import { deepClone } from "@/utils/base.js";
import Upload from "@/components/file/Upload";
import draggable from "vuedraggable";

export default {
  components: {
    Upload,
    draggable
  },
  data() {
    return {
      showBasics: true,
      showOther: false,
      isProductUpload: false,
      srcList: [],
      copyForm: {},
      rules: {},
      /*左边长度*/
      formLabelWidth: "100px",
      /*是否显示*/
      dialogVisible: false,
      /* 类型 */
      typeList: [],
      /* 表单Items */
      formLoading: false,
      loading: false,
      assets_type :'',
    };
  },
  props: ["on_edit","open_edit", "formData", "formItems", "autocompleteOptions"],
  created() {
    this.init();
    this.formItems.forEach(item => {
      if (item.type == "contract") {
        this.copyForm.contract = item.image;
        if(Number(item.image) === 0 || item.image == null) {
          this.copyForm.contract = []
        }
        this.copyForm.contract.forEach((v,index) => {
          this.srcList[index] = v.file_path
        })
      }
    })
  },
  watch: {
    on_edit(){

    }
  },
  methods: {
    showImg(img) {
      console.log(img)
      this.srcList[0] =  img
    },
    showFun(type) {
      if(type == 1 ) {
        this.showBasics = true;
        this.showOther = false;
      }else {
        this.showOther = true;
        this.showBasics = false;
      }
    },

    /*打开上传图片*/
    openProductUpload: function () {
      this.isProductUpload = true;
    },
    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }
        if(e.length == 1) {
          this.copyForm.contract.push(e[0])
        }else {
          e.forEach(v => {
            this.copyForm.contract.push(v)
          })
        }
        this.copyForm.contract.forEach((i,index) => {
          this.srcList[index] = i.file_path
        })
      }

      this.isProductUpload = false;
    },
    /*删除商品图片*/
    deleteImg(index) {
      this.copyForm.contract.splice(index,1);
    },

    /* 初始化数据 */
    async init() {
      this.dialogVisible = this.open_edit;
      this.copyForm = this.getFormData();
      this.rules = this.getFormRules(this.formItems);
    },

    /* 获取表单规则 */
    getFormRules(options) {
      return options.reduce((acc, cur) => {
        if (cur.rules) {
          const name = cur.name;
          acc = { ...acc, [name]: cur.rules };
        }
        return acc;
      }, {});
    },

    /* 获取表单数据 */
    getFormData() {
      const temp = deepClone(this.formData);
      if (
        temp.user_id != "" &&
        temp.user_id != undefined &&
        temp.user_id != null
      ) {
        const res =
          this.autocompleteOptions.find(item => {
            return item.user_id == temp.user_id;
          }) || {};
        temp.other_user_name = res.nickName;
      }
      return temp;
    },

    // 提交api表单
    submitApi() {
      this.$refs.copyForm.validate(valid => {
        if (valid) {
          this.loading = true;
          this.formLoading=true;
          this.$emit("submitForm", this.copyForm);
        } else {
          return false;
        }
      });
    },

    /* 处理搜索选中 */
    handleSelect(item) {
      this.copyForm.user_id = item.user_id;
    },

    /* 处理搜索框值改变 */
    handleChange(event) {
      const value = event.target.value;
      const res = this.autocompleteOptions.find(
        item => item.nickName === value
      );
      if (res) {
        this.copyForm.user_id = res.user_id;
      } else {
        this.copyForm.other_user_name = null;
      }
    },

    /* 搜索框 */
    querySearchAsync(item) {
      return (queryString, cb) => {
        const key = item.option ? item.option["value-key"] : "value";
        const results = queryString
          ? this.autocompleteOptions.filter(this.filter(queryString, key))
          : this.autocompleteOptions;
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          cb(results);
        }, 300);
      };
    },

    /* 过滤搜索 */
    filter(queryString, key = "value") {
      return state => {
        return (state[key] + "").includes(queryString);
      };
    },

    /*关闭弹窗*/
    dialogFormVisible() {
      this.$emit("closeDialog");
    }
  },
  updated(){
    if(this.on_edit && this.on_edit == false)  {
      this.loading = false;
      this.formLoading=false;
    }
  },
};
</script>

<style scoped>
.img-auto {
  width: 100%;
  height: 100%;
}
.select-box {
  display: flex;
  align-content: center;
  margin-left: 40px;
  margin-bottom: 18px;
}
.btn {
  width: 100px;
  height: 35px;
  text-align: center;
  line-height: 35px;
  border: 1px solid #ddd;
  border-radius: 5px;
  margin-right: 10px;
}
.active {
  color: #409eff;
  border: 1px solid #409eff;
  border-radius: 5px;
}

.contract-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.contract-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.contract-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.contract-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.contract-list .item:hover .delete-btn {
  display: block;
}


.contract-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.contract-list .img-select i {
  color: #409eff;
}</style>



// WEBPACK FOOTER //
// src/views/user_asset/all/part/Edit.vue